import React from 'react';
import NavBar from './NavBar';
import Header from './Header';
import About from './About';
import Footer from './Footer';
import Seo from '../Seo/Seo';
import { SITE_URL } from '../../constants';
import './Landing2.css';

const DESCRIPTION = 'Upload your screenplay and get a script breakdown, production budget estimate and script coverage in minutes. No subscription: pay only for the scripts you analyse.';

const STRUCTURED_DATA = [
    {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'Screenplayer',
        url: SITE_URL,
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        description: 'AI screenplay analysis for filmmakers: scene-by-scene script breakdown, cast, locations, props, costume, makeup, SFX and VFX lists, production budget estimate, script coverage with a scorecard, logline, summary and treatment.',
    },
    {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Screenplayer',
        url: SITE_URL,
        logo: `${SITE_URL}/logo512.png`,
        sameAs: [
            'https://x.com/screendj',
            'https://www.instagram.com/screenplayer.co.uk',
        ],
    },
];

function Landing2() {
    return (
        <div>
            <Seo
                title="Screenplayer – AI Script Breakdown, Film Budget Estimate & Script Coverage"
                description={DESCRIPTION}
                path="/"
                jsonLd={STRUCTURED_DATA}
            />
            <NavBar />
            <Header />
            <About />
            <Footer />
        </div>
    );
}

export default Landing2; 